<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>进件资料表</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                商家ID[资料ID]
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                商户类型
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                资料详情
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                申请状态
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                提交时间
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                备注/反馈
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                操作
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(submission, index) in paginatedSubmissions" :key="submission.data_id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar
                      :img="submission.img || img1"
                      size="sm"
                      border-radius="lg"
                      class="me-3"
                      alt="user-avatar"
                    />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ submission.deliver_id }}[{{submission.info_id}}] {{submission.deliver_name}}</h6>
                    <p class="text-xs text-secondary mb-0" style="display:none">{{index}}</p>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <span
                  :class="['badge badge-sm', getMerchantType(submission) === 'individual' ? 'bg-info' : 'bg-primary']"
                >
                  {{ getMerchantType(submission) === 'individual' ? '小微' : '企业' }}
                </span>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0" @click="toggleDetails(submission)">点击查看详情</p>
              </td>
              <td class="align-middle text-center text-sm">
                <!-- 下拉框选择状态 -->
                <select v-model="submission.status" class="form-select" @change="handleStatusChange(submission)">
                  <option value="new">新提交</option>
                  <option value="declined">驳回</option>
                  <option value="approved">通过</option>
                  <option value="handling">处理中</option>
                  <option value="closed">关闭</option>
                </select>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ formatDate(submission.created_date) }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span v-if="isAuthorized(submission)" class="badge bg-success" style="font-size: 0.7rem;">
                  已通过手机授权
                </span>
                <span v-else class="text-secondary text-xs font-weight-bold">
                  {{ submission.feedback || '无' }}
                </span>
              </td>
              <td class="align-middle text-center">
                <a
                  href="javascript:;"
                  class="text-secondary font-weight-bold text-xs me-3"
                  @click="handleDocDownload(submission)"
                >打包下载</a>
                <a
                  href="javascript:;"
                  class="text-secondary font-weight-bold text-xs"
                  @click="toggleConfig(submission)"
                >配置通道</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分页控制 -->
      <div class="d-flex justify-content-between align-items-center mt-3 px-3">
        <div class="d-flex align-items-center">
          <span class="text-sm me-2">每页显示</span>
          <input
            type="number"
            v-model.number="pageSize"
            class="form-control form-control-sm"
            style="width: 70px;"
            min="5"
            max="100"
            @change="onPageSizeChange"
          />
          <span class="text-sm ms-2">条</span>
        </div>
        <div class="d-flex align-items-center">
          <button
            class="btn btn-sm btn-outline-primary me-2"
            :disabled="currentPage === 1"
            @click="prevPage"
          >
            上一页
          </button>
          <span class="text-sm">第 {{ currentPage }} 页 / 共 {{ totalPages }} 页（共 {{ submissions.length }} 条）</span>
          <button
            class="btn btn-sm btn-outline-primary ms-2"
            :disabled="currentPage === totalPages"
            @click="nextPage"
          >
            下一页
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 使用 Vue modal 弹窗来显示 SubmissionDetails -->
  <div v-if="showDetails" class="modal-overlay">
    <div class="modal-content">
      <SubmissionDetails :submission="selectedSubmission" @close="closeDetails" />
    </div>
  </div>

  <!-- 使用 Vue modal 弹窗来显示 SubmissionDetails -->
  <div v-if="showConfig" class="modal-overlay">
    <div class="modal-content">
      <ChanelConfig :submission="selectedSubmission" @close="closeConfig" />
    </div>
  </div>
  <!-- 状态变更备注弹窗（支持所有状态） -->
  <div v-if="showRemarkPopup" class="modal-overlay">
    <div class="modal-content remark-modal">
      <h3>{{ remarkTitle }}</h3>
      <!-- 快捷反馈模板 -->
      <div class="remark-shortcuts mb-3">
        <small class="text-secondary">快捷反馈：</small>
        <div class="d-flex flex-wrap gap-2 mt-1">
          <button
            v-for="tpl in feedbackTemplates"
            :key="tpl"
            class="btn btn-outline-secondary btn-sm"
            style="font-size: 0.75rem; white-space: normal; text-align: left;"
            @click="remarkContent = tpl"
          >
            {{ tpl }}
          </button>
        </div>
      </div>
      <textarea v-model="remarkContent" rows="4" class="form-control" :placeholder="remarkPlaceholder"></textarea>
      <div class="mt-2 form-check">
        <input type="checkbox" class="form-check-input" id="sendSmsCheckbox" v-model="sendSmsNotification" />
        <label class="form-check-label" for="sendSmsCheckbox">同步发送短信通知</label>
      </div>
      <div class="mt-3 d-flex justify-content-end gap-2">
        <button class="btn btn-primary me-2" @click="confirmStatusChange">确认</button>
        <button class="btn btn-secondary" @click="closeRemarkPopup">取消</button>
      </div>
    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
//import SoftBadge from "@/components/SoftBadge.vue";
import SubmissionDetails from "./SubmissionDetails.vue"; // 引入 SubmissionDetails 组件
import ChanelConfig from "./ChanelConfig.vue"; // 引入 SubmissionDetails 组件
import img1 from "../../assets/img/file.jpeg";
import { getmerchpayinfos, getMerchPayInfosDownload, updateSubmissionStatus } from "@/api/merch.js"; // 引入获取进件资料的 API 和状态变更接口
import dayjs from "dayjs"; // 引入 dayjs 库处理时间

export default {
  name: "SubmissionTables",
  data() {
    return {
      img1,
      submissions: [], // 存储所有的进件数据
      showDetails: false, // 控制显示 SubmissionDetails
      showConfig: false, // 控制显示 ChanelConfig
      showRemarkPopup: false, // 控制是否显示备注弹窗
      selectedSubmission: null, // 选中的进件数据
      currentPage: 1, // 当前页码，默认为第一页
      pageSize: 20, // 每页显示的记录数
      paginatedSubmissions: [], // 当前页显示的数据
      totalPages: 1, // 总页数
      remarkTitle: "", // 备注弹窗标题
      remarkPlaceholder: "", // 备注弹窗占位符
      remarkContent: "", // 备注内容
      sendSmsNotification: false, // 是否同步发送短信通知（默认不勾选）
      pendingStatus: "", // 待变更的目标状态
      feedbackTemplates: [
        '请在手机上完成收钱吧短信授权，授权后请务必回来完成通知，以免延误渠道开通时间',
        '申请资料不符合要求，请提交真实照片，AI图，效果图无法通过审',
        '营业执照法人与身份证不符，请调整后重新提交',
        '法人与收款银行卡信息不符，请调增后重新提交',
        '请登录收钱吧app后台进行相关认证后即可正式收款',
      ],
    };
  },
  components: {
    SoftAvatar,
    //SoftBadge,
    SubmissionDetails, // 注册 SubmissionDetails 组件
    ChanelConfig,
  },
  methods: {
    // 获取进件数据
    fetchSubmissions() {
      getmerchpayinfos().then(response => {
        if (response.code === 0) {
          //console.log("get submissions:", response.desc);
          // 假设返回的数据是一个数组
          this.submissions = response.desc.map(submission => ({
            ...submission,
            submit_time: dayjs(submission.created_date).format("YYYY/MM/DD HH:mm:ss"), // 格式化时间
          }));
          // 计算总页数
          this.totalPages = Math.ceil(this.submissions.length / this.pageSize);
          this.updatePaginatedData(); // 更新当前页的数据
        } else {
          alert("获取进件资料失败：" + response.desc);
        }
      }).catch(error => {
        console.error("获取进件数据时出错：", error);
        alert("获取进件资料失败，请稍后再试。");
      });
    },

    // 处理下拉框选择变化（所有状态都弹出备注框）
    handleStatusChange(submission) {
      this.selectedSubmission = submission;
      this.pendingStatus = submission.status;
      this.remarkContent = "";
      this.sendSmsNotification = false; // 重置为不勾选

      // 根据目标状态设置弹窗标题和占位符
      const statusLabels = {
        'approved': '通过',
        'declined': '驳回',
        'handling': '处理中',
        'new': '新提交',
        'closed': '关闭'
      };
      const label = statusLabels[submission.status] || submission.status;
      this.remarkTitle = `设置状态为「${label}」，请输入备注信息`;
      this.remarkPlaceholder = `请输入${label}的备注说明（选填）`;
      this.showRemarkPopup = true;
    },

    // 确认状态变更
    confirmStatusChange() {
      updateSubmissionStatus({
        info_id: this.selectedSubmission.info_id,
        status: this.pendingStatus,
        remark: this.remarkContent || '',
        send_sms: this.sendSmsNotification ? 1 : 0
      })
      .then(response => {
        if (response.code === 0) {
          alert("状态更新成功！");
          this.showRemarkPopup = false;
          this.selectedSubmission.feedback = this.remarkContent || '';
          this.fetchSubmissions(); // 刷新列表数据
        } else {
          alert("状态更新失败：" + response.desc);
        }
      })
      .catch(error => {
        console.error("状态更新请求出错：", error);
        alert("状态更新失败，请稍后再试。");
      });
    },

    // 打包下载进件文件
    handleDocDownload(row) {
      getMerchPayInfosDownload({ deliver_id: row.deliver_id, info_id: row.info_id }).then(resp => {
        if (resp.code === 0) {
          window.open(resp.desc, '_blank')
        } else {
          alert('下载失败:' + resp.desc)
        }
      }).catch(err => {
        alert('下载失败:' + err)
      })
    },

    // 每页显示数量变更
    onPageSizeChange() {
      if (this.pageSize < 5) this.pageSize = 5
      if (this.pageSize > 100) this.pageSize = 100
      this.currentPage = 1
      this.totalPages = Math.ceil(this.submissions.length / this.pageSize)
      this.updatePaginatedData()
    },

    // 关闭备注弹窗
    closeRemarkPopup() {
      this.showRemarkPopup = false;
    },

    // 切换 SubmissionDetails 组件的显示状态，并传递当前行的数据
    toggleDetails(submission) {
      this.selectedSubmission = submission; // 选择当前进件数据
      this.showDetails = true; // 显示弹窗
    },

    toggleConfig(submission) {
      this.selectedSubmission = submission; // 选择当前进件数据
      this.showConfig = true; // 显示弹窗
    },

    // 关闭 SubmissionDetails
    closeConfig() {
      this.showConfig = false; // 关闭弹窗
    },

    closeDetails() {
      this.showDetails = false; // 关闭弹窗
    },

    // 从 pay_info JSON 中解析商户类型
    getMerchantType(submission) {
      try {
        const payInfo = typeof submission.pay_info === 'string'
          ? JSON.parse(submission.pay_info)
          : submission.pay_info
        return payInfo?.merchant_type || 'company'
      } catch {
        return 'company'
      }
    },

    // 检查进件是否已通过手机授权
    isAuthorized(submission) {
      return submission.status === 'handling'
        && submission.feedback
        && submission.feedback.includes('已通过手机授权')
    },

    // 格式化时间
    formatDate(timestamp) {     
      const newDate = dayjs(timestamp*1000).format("YYYY/MM/DD HH:mm:ss");
      //console.log("formating:", timestamp, "date:", newDate)
      return newDate
    },

    // 更新当前页显示的数据
    updatePaginatedData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = this.currentPage * this.pageSize;
      this.paginatedSubmissions = this.submissions.slice(startIndex, endIndex);
    },

    // 下一页
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updatePaginatedData();
      }
    },

    // 上一页
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updatePaginatedData();
      }
    },
  },

  mounted() {
    this.fetchSubmissions(); // 页面加载时获取进件数据
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 60%;
  max-width: 600px;
}

.remark-modal {
  max-width: 700px;
}

.modal-content h2 {
  margin-top: 0;
}

button {
  margin-top: 10px;
}
</style>
